import React from "react";

import { FormItemLayout, FormErrorMessage } from "..";
import CssTextField from "./styles";

const FormTextInput = ({
  label,
  required,
  textArea,
  onChange,
  value,
  errorValue,
  helper,
  ...textFieldProps
}) => {
  return (
    <>
      <FormItemLayout
        textArea={textArea}
        label={label}
        required={required}
        helper={helper}
      >
        <CssTextField
          fullWidth
          multiline={textArea}
          rows={2}
          value={value === null ? "-" : value}
          variant="outlined"
          onChange={onChange}
          autoComplete="off"
          {...textFieldProps}
        />
      </FormItemLayout>
      {errorValue && <FormErrorMessage errorMessage={errorValue} />}
    </>
  );
};

export default FormTextInput;
